import '@popperjs/core';
import * as bootstrap from 'bootstrap';
import 'htmx.org';
import 'plyr';
import './plyr-init';
// import 'chart.js'
// import 'chartjs-plugin-datalabels'
// import 'chart.js-plugin-labels-dv'
// import 'chartjs-adapter-date-fns'
// Make bootstrap available globally
window.bootstrap = bootstrap;
